{
  "language": {
    "name": "中文"
  },
  "nav": {
    "about": "关于",
    "expertise": "专业知识",
    "certifications": "认证",
    "connect": "联系"
  },
  "hero": {
    "badge": "可在新加坡从事医疗保健工作",
    "title": "连接北欧卓越与东南亚之心",
    "stats": {
      "certifications": "已验证认证",
      "languages": "语言能力",
      "geriatric": "老年护理专长"
    },
    "cta": {
      "download": "下载简历",
      "explore": "探索我的两个世界"
    }
  },
  "worlds": {
    "title": "我的两个世界",
    "finland": {
      "title": "芬兰：我受训的地方",
      "points": [
        "严格的循证医疗教育",
        "来自Duodecim的20多个专业认证",
        "专注于患者安全和质量改进",
        "芬兰医疗系统的高级临床技能"
      ]
    },
    "asia": {
      "title": "东南亚：我的归属",
      "points": [
        "泰国文化根源和家庭价值观",
        "了解亚洲医疗保健期望",
        "多语言沟通能力",
        "患者护理中的文化敏感性"
      ]
    },
    "bridge": {
      "title": "连接两个世界",
      "points": {
        "evidence": {
          "title": "循证实践",
          "desc": "芬兰培训与亚洲温暖相结合"
        },
        "cultural": {
          "title": "文化智慧",
          "desc": "应对多样化的患者需求"
        },
        "tech": {
          "title": "技术卓越",
          "desc": "现代医疗保健系统"
        },
        "family": {
          "title": "以家庭为中心的护理",
          "desc": "全面的治疗方法"
        }
      }
    }
  },
  "patient": {
    "title": "以患者为中心的沟通",
    "subtitle": "我如何调整沟通方式以满足不同患者的需求",
    "conversations": {
      "medication": {
        "patient": "我担心要吃这么多药。我女儿说太多了。",
        "nurse": "我理解您的担忧。让我解释每种药物及其对您康复的重要性。我们也可以与您的女儿和医生讨论，确保每个人都对治疗计划感到满意。"
      },
      "pain": {
        "patient": "疼痛越来越严重，但我不想打扰任何人。",
        "nurse": "您的舒适对我们非常重要。请不要犹豫告诉我们您的疼痛。让我评估您的疼痛程度，我们将共同有效地管理它。您的健康是我们的首要任务。"
      },
      "family": {
        "patient": "我的家人可以陪我吗？他们在这里时我感觉更好。",
        "nurse": "当然可以。家庭支持是康复的重要组成部分。让我们安排适合每个人的探视时间，同时确保您得到足够的休息。我们重视您家人参与您的护理。"
      }
    }
  },
  "cv": {
    "title": "个人简历",
    "sections": {
      "personalInfo": "个人信息",
      "summary": "专业摘要",
      "licenses": "护理注册与资格",
      "education": "教育背景",
      "experience": "专业经验",
      "certifications": "持续专业发展",
      "skills": "临床技能",
      "languages": "语言能力"
    },
    "personalInfo": {
      "fullName": "姓名",
      "dateOfBirth": "出生日期",
      "nationality": "国籍",
      "contact": "联系方式",
      "email": "电子邮件",
      "location": "当前位置"
    },
    "summary": "具有芬兰医疗培训和有效护理执照的注册护士。在外科、精神科、老年护理和急诊护理方面具有专业知识。在循证实践、患者安全和多学科协作方面具有经验。寻求为新加坡医疗保健系统贡献临床卓越和文化适应能力。",
    "licenses": {
      "nursing": {
        "title": "芬兰护理执照",
        "details": "注册护士（Sairaanhoitaja）| 注册号：10009985648 | 颁发机构：Valvira | 状态：有效"
      },
      "medication": {
        "title": "芬兰药物执照",
        "details": "执照类型：Love（Lääkkeenmääräämis Lupa hoitajille）| 状态：有效"
      }
    },
    "education": {
      "degree": "医疗保健学士（护理科学）",
      "institution": "LAB应用科学大学，拉赫蒂，芬兰",
      "year": "毕业年份"
    },
    "experience": {
      "responsibilities": "主要职责",
      "achievements": "主要成就",
      "0": {
        "title": "护理学生 - 急性护理单元",
        "organization": "Päijät-Häme中心医院",
        "location": "拉赫蒂，芬兰",
        "period": "2025年2月 - 2025年4月",
        "responsibilities": [
          "在急性护理环境中提供全面的患者护理，包括生命体征监测、药物管理和电子健康记录（LifeCare）文档记录",
          "执行临床程序，如静脉插管、心电图记录和各种患者护理干预",
          "与包括医生、物理治疗师和药剂师在内的多学科团队合作",
          "评估患者状况，对生命体征变化做出反应，并适当升级关注事项"
        ]
      },
      "1": {
        "title": "护理学生 - 手术室",
        "organization": "Etelä-Karjala中心医院",
        "location": "拉彭兰塔，芬兰",
        "period": "2025年1月 - 2025年2月",
        "responsibilities": [
          "在所有三个角色中获得全面的围手术期护理经验：麻醉护士、洗手护士和巡回护士",
          "协助外科手术，同时保持严格的无菌技术和无菌场协议",
          "使用先进的监测设备监测患者的生命体征和麻醉反应"
        ]
      },
      "2": {
        "title": "注册护士 - 外科病房",
        "organization": "Päijät-Häme中心医院，R5病房",
        "location": "拉赫蒂，芬兰",
        "period": "2024年12月 - 2025年2月",
        "responsibilities": [
          "在30床急性护理病房为外科患者提供全面的术前和术后护理",
          "根据医生指示和护理协议管理药物、静脉治疗和疼痛管理",
          "监测患者生命体征、伤口愈合和术后恢复"
        ],
        "achievements": [
          "成功管理需要复杂伤口护理的高急性度术后患者的护理",
          "通过仔细验证和记录保持100%的药物管理准确性"
        ]
      }
    },
    "certifications": {
      "0": {
        "category": "精神科与心理健康",
        "items": [
          "焦虑和失眠青年：青少年精神病学观点（55分钟）- 2024年11月",
          "动机性访谈（60分钟）- 2022年12月"
        ]
      },
      "1": {
        "category": "老年与老年护理",
        "items": [
          "老年衰弱识别（30分钟）- 2024年10月",
          "老年药物管理（60分钟）- 2024年9月",
          "老年多重用药（40分钟）- 2024年9月",
          "跌倒预防（60分钟）- 2024年9月"
        ]
      },
      "2": {
        "category": "急性与急诊护理",
        "items": [
          "神经系统患者急诊评估（60分钟）- 2023年11月",
          "使用ABCDE原则系统评估生命功能（30分钟）- 2023年10月",
          "中心静脉导管（CVK）插入和使用（70分钟）- 2023年11月"
        ]
      }
    },
    "skills": {
      "clinical": {
        "title": "患者护理能力",
        "items": [
          "全面的患者评估和生命体征监测",
          "高级伤口护理和敷料更换",
          "药物管理（口服、静脉、肌肉、皮下）",
          "静脉插管、导尿和鼻胃管管理",
          "疼痛评估和管理",
          "术前和术后患者护理"
        ]
      },
      "technical": {
        "title": "技术与临床系统",
        "items": [
          "LifeCare电子健康记录（EHR）系统",
          "医疗设备操作（生命体征监测器、输液泵、氧气输送系统）",
          "感染控制协议和无菌技术",
          "急诊响应协议和基本生命支持"
        ]
      },
      "soft": {
        "title": "软技能与专业素质",
        "items": [
          "出色的沟通和积极倾听技能",
          "强烈的同理心和以患者为中心的护理",
          "在多学科环境中有效的团队协作",
          "高压环境下的时间管理",
          "对多样化患者群体的文化敏感性"
        ]
      }
    },
    "languages": {
      "thai": "泰语",
      "finnish": "芬兰语",
      "english": "英语"
    },
    "languageProficiency": {
      "native": "母语",
      "fluent": "流利",
      "professional_b2": "专业水平（B2）"
    },
    "generated": "生成日期"
  },
  "footer": {
    "credentials": "注册护士，护理学学士",
    "privacy": "隐私政策",
    "terms": "使用条款",
    "copyright": "© {{year}} Mona。保留所有权利。"
  }
}